var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPNavLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_30)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6202 10.8612L10.8 8.4H9.9L10.3998 10.8H1.6002L2.1 8.4H1.2L0.379203 10.8612C0.171003 11.4876 0.540003 12 1.2 12H10.8C11.46 12 11.829 11.4876 11.6202 10.8612ZM9 3C9 2.20435 8.68393 1.44129 8.12132 0.87868C7.55871 0.316071 6.79565 0 6 0C5.20435 0 4.44129 0.316071 3.87868 0.87868C3.31607 1.44129 3 2.20435 3 3C3 5.865 6 9 6 9C6 9 9 5.865 9 3ZM4.38 3.036C4.38 2.82329 4.42191 2.61266 4.50333 2.41614C4.58475 2.21963 4.70409 2.04108 4.85453 1.8907C5.00497 1.74032 5.18356 1.62104 5.3801 1.5397C5.57665 1.45835 5.78729 1.41652 6 1.4166C6.42957 1.4166 6.84155 1.58725 7.1453 1.891C7.44906 2.19475 7.6197 2.60673 7.6197 3.0363C7.6197 3.46587 7.44906 3.87785 7.1453 4.1816C6.84155 4.48535 6.42957 4.656 6 4.656C5.57035 4.656 5.1583 4.48532 4.85449 4.18151C4.55068 3.8777 4.38 3.46565 4.38 3.036Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_30"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPNavLocation);
export default __webpack_public_path__ + "static/media/p_nav_location.9c02b558a5bde095553eafa3528035ab.svg";
export { ForwardRef as ReactComponent };